import React, { useCallback, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import useGetTaskList from '../hooks/task/get-task-list';
import useGetWalletInfo from '../hooks/wallet/get-wallet-info';

const Home = () => {
  // init
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const token = localStorage?.getItem('token')

  // api 
  const useGetTaskListInfinity = useGetTaskList({ token: token })
  const { data: walletInfoData, } = useGetWalletInfo({ token: token })

  const handleScroll = useCallback(() => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      if (scrollHeight - scrollTop <= clientHeight + 1) {
        useGetTaskListInfinity?.fetchNextPage();
      }
    }
  }, [useGetTaskListInfinity]);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);

  const formatAmount = (amount) => {
    const amountStr = amount.toString();
    if (amountStr.length <= 6) return amountStr;
    return amountStr.slice(0, 6) + '...';
  };

  return (
    <div className="font-sans h-screen bg-[#ffffff] flex flex-col">
      <div className="flex-shrink-0 flex flex-col w-full px-4 pt-4 pb-0">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <Link to={'/invitation'}>
            <svg className='fill-current w-8 h-8' viewBox="0 0 37 26" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M6.04862 25.0026C6.04862 20.3605 8.37502 16.4364 12.2368 14.3592C10.7014 12.6712 9.82255 10.4077 9.82255 8.00722C9.82255 5.59575 10.7014 3.39803 12.1386 1.75385C11.6526 1.64423 11.1512 1.58395 10.6342 1.58395C6.71552 1.58395 3.54646 4.94904 3.54646 9.09786C3.54646 11.745 4.8389 14.0578 6.7879 15.3896C2.81752 16.7762 0 20.2893 0 25.0629C0 25.589 0.387732 26 0.884029 26H6.27609C6.13134 25.6986 6.04862 25.3588 6.04862 25.0026ZM30.2173 15.3841C32.1663 14.0523 33.4587 11.7395 33.4587 9.09237C33.4587 4.93807 30.2845 1.57846 26.371 1.57846C25.854 1.57846 25.3525 1.63875 24.8666 1.74836C26.3038 3.39254 27.1826 5.59026 27.1826 8.00173C27.1826 10.4077 26.3038 12.6657 24.7683 14.3537C28.6302 16.4309 30.9565 20.355 30.9565 24.9971C30.9565 25.3588 30.8738 25.6986 30.7291 25.9946H36.116C36.6123 25.9946 37 25.5835 37 25.0574C37.0052 20.2892 34.1877 16.7762 30.2173 15.3841Z" fill="#141415" />
              <path d="M22.597 14.699C24.6701 13.2795 26.0504 10.8187 26.0504 8.00168C26.0504 3.58431 22.6746 0 18.5026 0C14.3358 0 10.9547 3.57883 10.9547 8.00168C10.9547 10.8187 12.3299 13.2795 14.4081 14.699C10.1844 16.1787 7.18597 19.9165 7.18597 24.997C7.18597 25.5561 7.59956 25.9945 8.12687 25.9945H28.8783C29.4056 25.9945 29.8192 25.5561 29.8192 24.997C29.8192 19.922 26.8207 16.1787 22.597 14.699Z" fill="#141415" />
            </svg>
          </Link>
          <Link to={'/withdraw'} >
            <svg className='fill-current w-8 h-8' viewBox="0 0 29 23" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M23.0666 17.6746C21.3418 17.6746 19.9849 16.2079 20.1919 14.4703C20.3759 13.0261 21.6638 11.9656 23.1586 11.9656H29V7.13657C29 6.50474 28.4711 6.0083 27.8501 6.0083H1.14988C0.505948 6.0083 0 6.5273 0 7.13657V21.8718C0 22.5036 0.528945 23 1.14988 23H27.8271C28.4711 23 28.977 22.481 28.977 21.8718V17.6746H23.0666V17.6746ZM21.2728 4.97025L19.87 0.727957C19.686 0.186388 19.088 -0.129527 18.5131 0.0509958L2.52975 5.12821L21.2728 4.97025V4.97025Z" fill="#141415" />
              <path d="M21.1946 14.7848C21.1946 15.9314 22.1419 16.8608 23.3104 16.8608C24.4789 16.8608 25.4262 15.9314 25.4262 14.7848C25.4262 13.6383 24.4789 12.7088 23.3104 12.7088C22.1419 12.7088 21.1946 13.6383 21.1946 14.7848V14.7848Z" fill="#141415" />
            </svg>
          </Link>

        </div>

        {/* Balance Section */}
        <div className="flex flex-col justify-center items-center mb-8 text-center">
          <h2 className="text-lg font-inter font-bold text-black">Total Balance</h2>
          <div className="text-4xl font-bold mb-2 text-black">{walletInfoData?.data?.data?.token_list[0]?.balance ?? 'N/A'} <span className="text-lg">{walletInfoData?.data?.data?.token_list[0]?.symbol?.toUpperCase() ?? 'N/A'}</span></div>
          <div className="flex items-center text-green-500 gap-1">
            <svg className='fill-current w-4 h-4' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C1.07288e-06 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12V12Z" fill="#00B556" />
              <path d="M14.7919 7.829L17.3719 10.409C17.6729 10.6895 17.7968 11.1118 17.695 11.5104C17.5932 11.909 17.282 12.2203 16.8834 12.3221C16.4848 12.4239 16.0624 12.3 15.7819 11.999L13.2019 9.41899V17.954C13.2019 18.5753 12.6983 19.079 12.0769 19.079C11.4556 19.079 10.9519 18.5753 10.9519 17.954V9.419L8.37194 11.999C7.92868 12.412 7.23793 12.3998 6.80952 11.9714C6.3811 11.543 6.36891 10.8523 6.78194 10.409L11.2819 5.909C11.7212 5.47032 12.4327 5.47032 12.8719 5.909L14.7919 7.829V7.829Z" fill="white" />
            </svg>
            <span className='text-[#9AA9BB] font-inter font-bold text-sm'>Today <span className='text-[#00B556] text-sm font-inter font-bold'>+${walletInfoData?.data?.data?.token_list[0]?.today_earn ?? 'N/A'}</span></span>
          </div>
        </div>
      </div>

      {/* Task List */}
      <div className="bg-[#141415] rounded-t-3xl flex-grow flex flex-col w-full overflow-hidden">
        <div className="flex justify-between items-center mb-2 mx-4">
          <div></div>
          <h3 className="text-lg font-inter font-bold p-4 text-white text-center mt-2">Task List</h3>
          <Link to={'/completedtasks'} >
            <svg className='fill-current w-7 h-7' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <path fillRule="evenodd" clipRule="evenodd" d="M7.26279 3.25871C7.38317 2.12953 8.33887 1.25 9.5 1.25H14.5C15.6611 1.25 16.6168 2.12953 16.7372 3.25871C17.5004 3.27425 18.1602 3.31372 18.7236 3.41721C19.4816 3.55644 20.1267 3.82168 20.6517 4.34661C21.2536 4.94853 21.5125 5.7064 21.6335 6.60651C21.75 7.47348 21.75 8.5758 21.75 9.94339V16.0531C21.75 17.4207 21.75 18.523 21.6335 19.39C21.5125 20.2901 21.2536 21.048 20.6517 21.6499C20.0497 22.2518 19.2919 22.5107 18.3918 22.6317C17.5248 22.7483 16.4225 22.7483 15.0549 22.7483H8.94513C7.57754 22.7483 6.47522 22.7483 5.60825 22.6317C4.70814 22.5107 3.95027 22.2518 3.34835 21.6499C2.74643 21.048 2.48754 20.2901 2.36652 19.39C2.24996 18.523 2.24998 17.4207 2.25 16.0531V9.94339C2.24998 8.5758 2.24996 7.47348 2.36652 6.60651C2.48754 5.7064 2.74643 4.94853 3.34835 4.34661C3.87328 3.82168 4.51835 3.55644 5.27635 3.41721C5.83977 3.31372 6.49963 3.27425 7.26279 3.25871ZM7.26476 4.75913C6.54668 4.77447 5.99332 4.81061 5.54735 4.89253C4.98054 4.99664 4.65246 5.16382 4.40901 5.40727C4.13225 5.68403 3.9518 6.07261 3.85315 6.80638C3.75159 7.56173 3.75 8.56285 3.75 9.99826V15.9983C3.75 17.4337 3.75159 18.4348 3.85315 19.1901C3.9518 19.9239 4.13225 20.3125 4.40901 20.5893C4.68577 20.866 5.07435 21.0465 5.80812 21.1451C6.56347 21.2467 7.56458 21.2483 9 21.2483H15C16.4354 21.2483 17.4365 21.2467 18.1919 21.1451C18.9257 21.0465 19.3142 20.866 19.591 20.5893C19.8678 20.3125 20.0482 19.9239 20.1469 19.1901C20.2484 18.4348 20.25 17.4337 20.25 15.9983V9.99826C20.25 8.56285 20.2484 7.56173 20.1469 6.80638C20.0482 6.07261 19.8678 5.68403 19.591 5.40727C19.3475 5.16382 19.0195 4.99664 18.4527 4.89253C18.0067 4.81061 17.4533 4.77447 16.7352 4.75913C16.6067 5.87972 15.655 6.75 14.5 6.75H9.5C8.345 6.75 7.39326 5.87972 7.26476 4.75913ZM9.5 2.75C9.08579 2.75 8.75 3.08579 8.75 3.5V4.5C8.75 4.91421 9.08579 5.25 9.5 5.25H14.5C14.9142 5.25 15.25 4.91421 15.25 4.5V3.5C15.25 3.08579 14.9142 2.75 14.5 2.75H9.5ZM15.5483 10.4883C15.8309 10.7911 15.8146 11.2657 15.5117 11.5483L11.226 15.5483C10.9379 15.8172 10.4907 15.8172 10.2025 15.5483L8.48826 13.9483C8.18545 13.6657 8.16908 13.1911 8.45171 12.8883C8.73433 12.5854 9.20893 12.5691 9.51174 12.8517L10.7143 13.9741L14.4883 10.4517C14.7911 10.1691 15.2657 10.1854 15.5483 10.4883Z" fill="#ffffff"></path></g>
            </svg>
          </Link>
        </div>
        <div className="overflow-y-auto flex-grow" ref={scrollRef}>
          {(useGetTaskListInfinity.isLoading || useGetTaskListInfinity?.isPending) ? (
            <div className="flex items-center justify-center h-full">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#00FF79]"></div>
            </div>
          ) : (
            useGetTaskListInfinity?.data?.pages[0]?.data?.data?.list?.length > 0 ?
              useGetTaskListInfinity?.data?.pages?.map((data, index) => {

                return data?.data?.data?.list?.map((item, index) => {
                  // console.log(item);
                  return (
                    <div
                      onClick={() => { navigate('/exchange', { state: { task: item } }) }}
                      key={index}
                      className="flex items-center p-4 border-b border-gray-700 last:border-b-0"
                    >
                      <div className="w-14 h-14 rounded-2xl mr-2 sm:mr-4 flex-shrink-0 flex items-center justify-center overflow-hidden">
                        <img
                          src={item?.icon}
                          alt="Task icon"
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="flex-grow mr-2 min-w-0">
                        <div className="font-inter font-bold text-white text-sm sm:text-base truncate">{item?.name}</div>
                        <div className="text-[#7F858F] font-inter font-medium text-xs sm:text-sm line-clamp-2">
                          {item?.content}
                        </div>
                      </div>

                      <div className="flex flex-col items-end">

                        <div className={`mt-1 ${item?.show_status === 3 ? 'text-[#28A3E2]' :
                          item?.show_status === 2 ? 'text-red-500' : item?.show_status === 1 ? 'text-[#BE68BE]' :
                            item?.show_status === 0 ? 'text-[#D5C17A]' : item?.show_status === 4 ? 'text-[#15E377]' : 'text-[#579876]'
                          } text-xs font-inter font-light`}>
                          {item?.show_status === 3 ? 'Waiting to claim' :
                            item?.show_status === 2 ? 'Failed Review' : item?.show_status === 1 ? 'Pending Review' :
                              item?.show_status === 0 ? 'Incomplete' : item?.show_status === 4 ? 'Completed' : 'N/A'}
                        </div>
                        <div className="text-[#00FF79] font-bold text-3xl sm:text-base whitespace-nowrap">
                          <span className="truncate max-w-[120px]">{formatAmount(item?.amount)} </span>
                          <span className='text-[#00FF79] text-xs font-inter font-bold'>{item?.symbol?.toUpperCase()}</span>
                        </div>
                      </div>

                    </div>
                  )
                })
              })
              : (
                <div className="flex-grow flex items-center justify-center" style={{ minHeight: '100%' }}>
                  <div className="text-white text-lg font-inter font-bold">No Task Found</div>
                </div>
              )
          )}

          {(useGetTaskListInfinity?.isFetchingNextPage) && (
            <div className="flex-grow flex items-center justify-center h-24">
              <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#00FF79]"></div>
            </div>)}

        </div>
      </div>
    </div>
  );
};

export default Home;